import {setRoles, setUsername} from "reducers/userSlice"

export const userActions = {
    clearData
}

function clearData(dispatch) {
    dispatch(setRoles([]))
    dispatch(setUsername(''))
}